<template>
  <div class="container">
    <ProductsMenu @productsSelect="productsSelect"/>
    <div>
      <div class="introduction">
        <div class="title" data-aos="fade-up">生物样本库建设整体规划服务</div>
        <div class="introductionContent">
          <div><img :src="require('@/assets/img/products/service/serviceContent1.png')" data-aos="zoom-in-up"></div>
          <div data-aos="fade-down">上海唐顾信息技术有限公司提供生物样本库建设整体规划服务，为客户提供生物样本库建设咨询、规划设计等配套服务</div>
          <div><img :src="require('@/assets/img/products/service/serviceContent2.png')" data-aos="zoom-in-up"></div>
          <div data-aos="fade-right">上海唐顾信息技术有限公司的设计方案更注重生物样本库运营过程中的规范化管理</div>
          <div><img :src="require('@/assets/img/products/service/serviceContent3.png')" data-aos="zoom-in-up"></div>
          <div data-aos="fade-left">可因地制宜为客户提供兼具特色的生物样本库设计方案，为客户建设专业化标准化的样本库建设提供技术支撑</div>
        </div>
        <table class="introductionTable">
          <thead>
          <tr data-aos="fade-up">
            <td>序号</td>
            <td>名称</td>
            <td>内容</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in introduction" data-aos="fade-up">
            <td>{{index+1}}</td>
            <td>{{item.name}}</td>
            <td>{{item.content}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div style="width: 100%;display: flex;align-items: center;justify-content: center;margin-bottom: 160px">
        <img :src="require('@/assets/img/products/service/caseContent.png')" data-aos="zoom-in-up">
      </div>
    </div>
  </div>
</template>

<script>
import ProductsMenu from "../../components/ProductsMenu";
export default {
  name: "site",
  components: {ProductsMenu},
  data(){
    return{
      introduction:[
        {name:'实验室规划、布局、装修',content:'吊顶装修、隔墙装修、地面装修、圆弧结构门窗制作安装、不锈钢传递窗、手消毒系统'},
        {name:'实验室供电系统',content:'照明电器、紫外线灭菌灯、开关插座、动力配电心'},
        {name:'实验室自动化控制系统',content:'风机、空调、压力、通风橱、温湿度控制系统等'},
        {name:'实验室弱电规划',content:'视频监控、弱电综合网络系统'},
        {name:'实验室净化、空调、排风设计及施TE',content:'净化级别、送/回/排风系统、压差控制、净化空调机组、空调冷热源'},
        {name:'实验室配套',content:'水盆/水槽/水龙头、洗眼器/紧急喷淋系统滴水架、试剂架、中央实验台、实验边台高温台、天平台、不锈钢操作台、药品柜/器血柜/钢瓶柜/样品柜、通风橱/通风罩/原子吸收罩'},
      ]
    }
  },
  methods:{
    productsSelect(src){
      this.$emit('productsSelect',src)
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  padding-left: 20%;
  box-sizing: border-box;
  position: relative;
}
.introduction{
  .title{
    width: 417px;
    height: 58px;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #ed1c24;
    margin: 213px auto 116px;
    background: url('../../assets/img/products/service/serviceTitle.png') no-repeat;
    text-align: center;
  }
  .introductionContent{
    display: flex;
    flex-wrap: wrap;
    width: 1220px;
    margin: 0 auto;
    div{
      width: 406px;
      height: 222px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 40px;
      box-sizing: border-box;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 23px;
      letter-spacing: 1px;
      color: #000000;
    }
  }
  .introductionTable{
    width: 982px;
    margin: 136px auto 95px;
    thead{
      td{
        height: 36px;
        background: #e3efff;
        font-size: 15px;
        text-align: center;
        letter-spacing: 1px;
      }
    }
    tbody{
      td{
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #333333;
        background: #f3f3f3;
        box-sizing: border-box;
      }
      td:nth-child(1){
        width: 105px;
        padding: 0;
        text-align: center;
      }
      td:nth-child(2){
        width: 366px;
        padding: 30px 35px;
      }
      td:nth-child(3){
        width: 504px;
        padding: 11px 18px;
      }
    }
  }
}
.case{
  .title{
    width: 512px;
    height: 67px;
    background: url("../../assets/img/products/service/caseTitle.png") no-repeat;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #ed1c24;
    margin: 0 auto 76px;
    text-align: center;
    line-height: 30px;
  }
  .content{
    width: 100%;
    background: #e3efff;
    text-align: center;
    padding: 17px 0 69px;
    .contentTitle{
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
    }
    .text{
      width: 960px;
      margin: 7px auto 26px;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 24px;
      letter-spacing: 1px;
      text-align: left;
      text-indent:2em;
    }
  }
}
.range{
  width: 956px;
  margin: 111px auto 0;
  .title{
    width: 127px;
    height: 27px;
    background-color: #006efd;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 27px;
    letter-spacing: 2px;
    color: #ffffff;
    text-align: center;
  }
  .rangeContent{
    width: 915px;
    margin: 30px 0 94px 23px;
    box-sizing: border-box;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 1px;
  }
  .training{
    margin-top: 88px;
    display: flex;
    .trainingContent{
      width: 304px;
      height: 95px;
      border-left: 5px solid #006efd;
      padding-left: 106px;
      box-sizing: border-box;
      padding-top: 22px;
      margin-bottom: 8px;
      div:nth-child(1){
        width: 193px;
        height: 51px;
        line-height: 51px;
        text-align: center;
        font-size: 20px;
        letter-spacing: 27px;
        color: #006efd;
        border: 1px solid #006efd;
        box-sizing: border-box;
        padding-left: 30px;
      }
      div:nth-child(2){
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 2px;
        color: #006efd;
        text-align: center;
        margin-top: 15px;
      }
    }
    .trainingContent:nth-child(2){
      border-color: #ed1c24;
    }
    &>div:nth-child(2){
      margin-left: 142px;
    }

  }
}
.trainingList{
  width: 100%;
  height: 687px;
  background: url("../../assets/img/products/service/trainingListBg.png") no-repeat;
  display: flex;
  box-sizing: border-box;
  flex-wrap: wrap;
  padding: 115px 278px;
  justify-content: space-between;
  .trainingListContent{
    width: 25.1%;
    .img{
      width: 115px;
      height: 115px;
      background:rgba(0,160,233,0.08);
      border: solid 1px rgba(0,0,0,0.08);
      border-radius: 50%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      margin:  0 auto;
    }
    .content{
      margin-top: 15px;
      display: flex;
      justify-content: center;
      span{
        display: inline-block;
      }
      span:nth-child(1){
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #ffffff;
        height: 37px;
        line-height: 37px;
      }
      span:nth-child(2){
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #ffffff;
        border-left: 1px solid #fff;
        height: 37px;
        line-height: 37px;
        margin-left: 15px;
        padding-left: 13px;
      }
    }
  }
  .trainingListContent:nth-child(n+4){
    margin-top: 90px;
  }
}
.service{
  text-align: center;
  .title{
    width: 502px;
    height: 67px;
    line-height: 30px;
    text-align: center;
    margin: 55px auto 65px;
    background: url("../../assets/img/products/service/approvalTitle.png") no-repeat;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #ed1c24;

  }
  img{
    margin-bottom: 64px;
  }
  .text{
    width: 1030px;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
    margin: 0 auto;
    text-indent: 2em;
    text-align: left;
  }
}
.approval{
  width: 100%;
  height: 687px;
  background: url("../../assets/img/products/service/approvalBg.png");
  margin-top: 75px;
  &>div{
    width: 1000px;
    margin: 0 auto;
    padding-top: 80px;
    .title{
      width: 127px;
      height: 27px;
      background-color: #006efd;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 27px;
      letter-spacing: 2px;
      color: #ffffff;
      margin-bottom: 90px;
      text-align: center;
    }
    .list{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .content{
        display: flex;
        padding-left: 45px;
        margin-bottom: 97px;
        .left{
          width: 118px;
          height: 130px;
          background-color: #ffffff;
          border-radius: 10px;
          .ellipse{
            margin-left: 32.5px;
            margin-top: -22.5px;
            width:45px;
            height:45px;
            background: #006efd;
            border-radius: 100px;
            text-align: center;
            color: #fff;
            font-size: 10px;
            padding-top: 6px;
            box-sizing: border-box;
            &:after{
              content: '';
              display:inline-block;
              width:47px;
              height: 32.5px;
              position:relative;
              opacity: 0.25;
              background: #006efd;
              top:-40%;
              left:-1px;
              border-bottom-left-radius: 50px;
              border-bottom-right-radius: 50px;
            }
          }
          .text{
            text-align: center;
            margin-top: 30px;
            font-size: 15px;
            line-height: 25px;
          }
        }
        .right{
          width: 76px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          i{
            color: #fff;
            font-size: 30px;
          }
        }
      }
    }
  }

}
.third{
  text-align: center;
  margin-top: 80px;
  .title{
    width: 360px;
    height: 67px;
    line-height: 30px;
    background: url("../../assets/img/products/service/thirdTitle.png") no-repeat;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 2px;
    color: #ed1c24;
    margin: 0 auto;
    text-align: center;
  }
  &>img{
    margin: 65px 0;
  }
  .text{
    width: 1030px;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
    text-indent: 2em;
    margin: 0 auto;
    text-align: left;
  }
  .service{
    width: 1030px;
    margin: 78px auto;
    .thirdTitle{
      width: 127px;
      height: 27px;
      background-color: #006efd;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 27px;
      letter-spacing: 2px;
      color: #ffffff;
      text-align: center;
    }
    .list{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 78px;
      &>div{
        width: 276px;
        height: 250px;
        margin-bottom: 20px;
        padding-top: 53px;
        box-sizing: border-box;
        &>div:nth-child(1){
          width: 80px;
          height: 80px;
          border-radius: 80px;
          border: 1px solid #fff;
          margin:  0 auto 34px;
          text-align: center;
          padding-top: 15px;
          box-sizing: border-box;
          img{
            width: 50px;
          }
        }
        &>div:nth-child(2){
          font-size: 19px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 27px;
          letter-spacing: -1px;
          color: #ffffff;
        }
      }
      &>div:nth-child(n){
        background-color: #006efd
      }
      &>div:nth-child(2n){
        background-color: #c1dcff;
      }
      &>div:nth-child(1){
        &>div:nth-child(1){
          padding-top: 25px;
        }
      }
      &>div:nth-child(3){
        &>div:nth-child(1){
          padding-top: 16px;
          img{
            margin-left: 5px;
          }
        }
      }
      &>div:nth-child(6){
        &>div:nth-child(1){
          padding-top: 12px;
          img{
            margin-left: -5px;
          }
        }
      }
    }
  }

}
</style>